export default __webpack_public_path__ + "static/media/48-min.f6160848.jpg";